/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Comparison_Opencomparetray2Inputs */

const id_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buka baki perbandingan, ${i?.count} dipilih`)
};

const ms_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buka dulang perbandingan, ${i?.count} dipilih`)
};

const da_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Åbn sammenligningsbakke, ${i?.count} valgt`)
};

const de_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vergleichsfeld öffnen, ${i?.count} ausgewählt`)
};

const en_us2_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open compare tray, ${i?.count} selected`)
};

const es_es2_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir bandeja de comparación, ${i?.count} seleccionados`)
};

const es_mx2_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir bandeja de comparación, ${i?.count} seleccionados`)
};

const fil_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buksan ang compare tray, ${i?.count} napili`)
};

const fr_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir le panneau de comparaison, ${i?.count} sélectionné(s)`)
};

const it_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apri pannello confronto, ${i?.count} selezionati`)
};

const hu_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Összehasonlító panel megnyitása, ${i?.count} kiválasztva`)
};

const nl_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open vergelijkingslade, ${i?.count} geselecteerd`)
};

const no_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Åpne sammenligningsskuff, ${i?.count} valgt`)
};

const pl_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otwórz panel porównania, ${i?.count} wybranych`)
};

const pt_br2_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Compare Tray (${i?.count})`)
};

const pt_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir painel de comparação, ${i?.count} selecionados`)
};

const ro_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deschide tava de comparare, ${i?.count} selectate`)
};

const fi_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avaa vertailualusta, ${i?.count} valittu`)
};

const sv_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Öppna jämför-fack, ${i?.count} valda`)
};

const vi_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mở khay so sánh, ${i?.count} đã chọn`)
};

const tr_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Karşılaştırma tepsisini aç, ${i?.count} seçildi`)
};

const cs_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Otevřít porovnávací panel, ${i?.count} vybráno`)
};

const bg_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отваряне на тавата за сравнение, ${i?.count} избрани`)
};

const ru_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть панель сравнения, выбрано ${i?.count}`)
};

const uk_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Відкрити панель порівняння, вибрано ${i?.count}`)
};

const ar_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`فتح درج المقارنة، ${i?.count} محدد`)
};

const hi_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`तुलना ट्रे खोलें, ${i?.count} चयनित`)
};

const th_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เปิดถาดเปรียบเทียบ เลือก ${i?.count} รายการ`)
};

const ja_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`比較トレイを開く（${i?.count} 件選択）`)
};

const zh_cn2_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Compare Tray (${i?.count})`)
};

const zh_hant1_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Compare Tray (${i?.count})`)
};

const ko_components_comparison_opencomparetray2 = /** @type {(inputs: Components_Comparison_Opencomparetray2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Compare Tray (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Open compare tray, {count} selected" |
*
* @param {Components_Comparison_Opencomparetray2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_opencomparetray2 = /** @type {((inputs: Components_Comparison_Opencomparetray2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Opencomparetray2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_opencomparetray2(inputs)
	if (locale === "ms") return ms_components_comparison_opencomparetray2(inputs)
	if (locale === "da") return da_components_comparison_opencomparetray2(inputs)
	if (locale === "de") return de_components_comparison_opencomparetray2(inputs)
	if (locale === "en-US") return en_us2_components_comparison_opencomparetray2(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_opencomparetray2(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_opencomparetray2(inputs)
	if (locale === "fil") return fil_components_comparison_opencomparetray2(inputs)
	if (locale === "fr") return fr_components_comparison_opencomparetray2(inputs)
	if (locale === "it") return it_components_comparison_opencomparetray2(inputs)
	if (locale === "hu") return hu_components_comparison_opencomparetray2(inputs)
	if (locale === "nl") return nl_components_comparison_opencomparetray2(inputs)
	if (locale === "no") return no_components_comparison_opencomparetray2(inputs)
	if (locale === "pl") return pl_components_comparison_opencomparetray2(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_opencomparetray2(inputs)
	if (locale === "pt") return pt_components_comparison_opencomparetray2(inputs)
	if (locale === "ro") return ro_components_comparison_opencomparetray2(inputs)
	if (locale === "fi") return fi_components_comparison_opencomparetray2(inputs)
	if (locale === "sv") return sv_components_comparison_opencomparetray2(inputs)
	if (locale === "vi") return vi_components_comparison_opencomparetray2(inputs)
	if (locale === "tr") return tr_components_comparison_opencomparetray2(inputs)
	if (locale === "cs") return cs_components_comparison_opencomparetray2(inputs)
	if (locale === "bg") return bg_components_comparison_opencomparetray2(inputs)
	if (locale === "ru") return ru_components_comparison_opencomparetray2(inputs)
	if (locale === "uk") return uk_components_comparison_opencomparetray2(inputs)
	if (locale === "ar") return ar_components_comparison_opencomparetray2(inputs)
	if (locale === "hi") return hi_components_comparison_opencomparetray2(inputs)
	if (locale === "th") return th_components_comparison_opencomparetray2(inputs)
	if (locale === "ja") return ja_components_comparison_opencomparetray2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_opencomparetray2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_opencomparetray2(inputs)
	return ko_components_comparison_opencomparetray2(inputs)
});
export { components_comparison_opencomparetray2 as "components.comparison.openCompareTray" }